import React from "react";
import { useTranslation } from "react-i18next";

import Layout from "../../../components/v2/Layout";
import PageTitle from "../../../components/v2/PageTitle";
import DepartmentsTable from "../../../components/v2/QuemEQuem/DepartmentsTable";
import Prosecutor, {
  ProsecutorRole,
} from "../../../components/v2/QuemEQuem/Prosecutor";
import TextLink from "../../../components/TextLink";

import helioChagas from "../../../assets/images/quemEQuem/v2/helio-chagas.webp";
import joaoPauloNogueira from "../../../assets/images/quemEQuem/v2/joao-paulo-nogueira.webp";
import marcelaVilaNova from "../../../assets/images/quemEQuem/v2/marcela-vila-nova.webp";
import rodrigoDias from "../../../assets/images/quemEQuem/v2/rodrigo-dias.webp";
import romuloLeitao from "../../../assets/images/quemEQuem/v2/romulo-leitao.webp";
import andreLeite from "../../../assets/images/quemEQuem/v2/andre-leite.webp";

import style from "./styles.module.scss";

const keyI18n = "translations.whoswho";
const lawUrl = "/leis_complementares/lei_complementar_315.pdf";

interface ProsecutorEntry {
  slug: string;
  name: string;
  image: string;
  role: ProsecutorRole;
  collapsible: boolean;
}

const prosecutors: ProsecutorEntry[] = [
  {
    slug: "helio",
    name: "Hélio das Chagas Leitão Neto",
    image: helioChagas,
    role: "general",
    collapsible: true,
  },
  {
    slug: "romulo",
    name: "Rômulo Leitão",
    image: romuloLeitao,
    role: "deputy",
    collapsible: true,
  },
  {
    slug: "rodrigo",
    name: "Rodrigo C. Dias",
    image: rodrigoDias,
    role: "deputy",
    collapsible: false,
  },
  {
    slug: "andreLeite",
    name: "André Diego de Lima Leite",
    image: andreLeite,
    role: "deputy",
    collapsible: false,
  },
  {
    slug: "marcela",
    name: "Marcela Vila Nova",
    image: marcelaVilaNova,
    role: "deputy",
    collapsible: true,
  },
  {
    slug: "joaoPaulo",
    name: "João Paulo de Sousa Barbosa Nogueira",
    image: joaoPauloNogueira,
    role: "deputy",
    collapsible: false,
  },
];

export default function QuemEQuem() {
  const { t } = useTranslation();

  return (
    <Layout title={t(`${keyI18n}.title`)}>
      <div className={style.body}>
        <PageTitle
          subtitle={t(`${keyI18n}.subtitle`)}
          title={t(`${keyI18n}.title`)}
        />

        <section className={style.section}>
          <header className={style.sectionHeader}>
            <h2 className={`pgm-label-large ${style.sectionName}`}>
              {t(`${keyI18n}.prosecutors.sectionName`)}
            </h2>
          </header>

          {prosecutors.map(({ slug, name, image, role, collapsible }) => (
            <Prosecutor
              bioKey={`${keyI18n}.prosecutors.people.${slug}.bio`}
              collapsible={collapsible}
              image={image}
              key={slug}
              name={name}
              positionKey={`${keyI18n}.prosecutors.people.${slug}.position`}
              role={role}
            />
          ))}
        </section>

        <section className={style.section}>
          <header className={style.sectionHeader}>
            <h2 className={`pgm-label-large ${style.sectionName}`}>
              {t(`${keyI18n}.departments.sectionName`)}
            </h2>
          </header>

          <p className={`pgm-body-large ${style.explanation}`}>
            {t(`${keyI18n}.departments.explanationBefore`)}{" "}
            <TextLink
              className="pgm-title-medium"
              link={lawUrl}
              target="_blank"
              text={t(`${keyI18n}.departments.law`)}
            />
            {t(`${keyI18n}.departments.explanationAfter`)}
          </p>

          <DepartmentsTable />
        </section>
      </div>
    </Layout>
  );
}
